module.exports = __webpack_public_path__ + "assets/img/base.3a222055.png";